/**
 * Cards de status da listagem de NF-e de saída (filtro rápido).
 * Todas = 0 é o card "Todas", selecionado por padrão.
 * Espelha ResumoNotaFiscalSaidaEnum (API RepoDFe), com os mesmos valores. Os valores são do card
 * e não são ids de StatusNFeSaidaEnum; Denegada não tem card (só o aviso da listagem). O card Pendentes é o de Aguardando transmissão.
 */
export enum ResumoNotaFiscalSaidaEnum {
  Todas = 0,
  Pendentes = 1,
  Rejeitadas = 3,
  Autorizadas = 5,
  Canceladas = 6,
  EmTransmissao = 7,
}
